export const isOfferExpired = (expirationDate) => {
    if (!expirationDate) {
        return false;
    }
    try {
        return new Date() >= new Date(expirationDate);
    }
    catch {
        return false;
    }
};

// @zapier/upsells@5.0.1 (c64b11b3c)
